import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

interface Args {
	isOn: boolean;
	isForPrimary: boolean;
	toggle: () => void;
}

export default class DataSelectEditAutoUpdateComponent extends Component<Args> {
	tooltipText =
		'Datablocks are very customizable, but by default the multiple settings are interconnected. When you disable autoupdate on a certain setting, none of the changes to other settings on this datablock will affect it anymore. We recommend to keep autoupdate enabled to make sure all parts of the datablock are in sync.';

	get text() {
		const isJustForDateRange = this.args.isForPrimary;
		if (this.args.isOn) {
			return isJustForDateRange
				? 'The date range is auto-updated and kept in sync with the other metrics on the block.'
				: 'These settings are auto-updated from the metric settings in the first tab.';
		} else {
			return isJustForDateRange
				? 'The date range is not being updated from the block anymore.'
				: 'These settings are not being auto-updated anymore.';
		}
	}
	<template>
		{{#if @isOn}}
			<div class="disabledLayer"></div>
		{{/if}}

		<div class="autoUpdate noText">
			<p>
				{{this.text}}
				<a role="button" {{on "click" @toggle}}>
					{{#if @isOn}}Disable{{else}}Enable{{/if}}
					auto-update
				</a>
				<ToolTipWithIconComponent @text={{this.tooltipText}} />
			</p>
		</div>
	</template>
}
